
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8292 7.82927C16.8292 10.4964 14.6671 12.6585 11.9999 12.6585C9.33279 12.6585 7.17065 10.4964 7.17065 7.82927C7.17065 5.16214 9.33279 3 11.9999 3C14.6671 3 16.8292 5.16214 16.8292 7.82927ZM12.8764 14.876C12.3204 15.786 12 16.8556 12 18C12 19.0929 12.2922 20.1175 12.8027 21H3.21948V19.1631C3.21948 17.5826 4.27051 16.1927 5.79568 15.7773C7.4587 15.3234 9.72934 14.8536 12 14.8536C12.2926 14.8536 12.5851 14.8614 12.8764 14.876Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16.0571 14.7771C15.9541 14.5195 15.6879 14.3662 15.4134 14.4062C15.1388 14.4463 14.9276 14.6693 14.9025 14.9456L14.4025 20.4456L15.5975 20.5543L15.8712 17.5436L16.9429 20.2228C17.0459 20.4804 17.3121 20.6337 17.5867 20.5936C17.8612 20.5536 18.0724 20.3305 18.0975 20.0543L18.5975 14.5543L17.4025 14.4456L17.1288 17.4563L16.0571 14.7771ZM19.6 17.4999C19.6 16.7429 19.7548 16.2444 19.9425 15.9555C20.1195 15.683 20.317 15.5999 20.5 15.5999C20.683 15.5999 20.8805 15.683 21.0575 15.9555C21.2452 16.2444 21.4 16.7429 21.4 17.4999C21.4 18.257 21.2452 18.7555 21.0575 19.0444C20.8805 19.3169 20.683 19.3999 20.5 19.3999C20.317 19.3999 20.1195 19.3169 19.9425 19.0444C19.7548 18.7555 19.6 18.257 19.6 17.4999ZM20.5 14.3999C19.8546 14.3999 19.3021 14.7385 18.9362 15.3018C18.581 15.8486 18.4 16.6001 18.4 17.4999C18.4 18.3997 18.581 19.1512 18.9362 19.6981C19.3021 20.2614 19.8546 20.5999 20.5 20.5999C21.1454 20.5999 21.6979 20.2614 22.0638 19.6981C22.4191 19.1512 22.6 18.3997 22.6 17.4999C22.6 16.6001 22.4191 15.8486 22.0638 15.3018C21.6979 14.7385 21.1454 14.3999 20.5 14.3999Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowExemptionLoginFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
